import { useEffect, useState } from 'react';

/**
 * `useDebouncedValue` — the ONE shared debounce for search-as-you-type (DNKADM-0340 U1).
 *
 * Returns `value` only after `delayMs` of quiet, so a picker that keys its fetch off the
 * debounced value issues at most one request per pause instead of one per keystroke.
 * Lifted verbatim from the local copies that `AddMemberDialog` and `MemberSearchDialog`
 * each carried (same 250 ms delay in both); those copies are gone and every
 * server-backed search box uses this hook. The timer is a genuine external-system sync,
 * which is why this is an effect and not derived state.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
